(() => {
  if (window.__snkrsRotatorBound) return;
  window.__snkrsRotatorBound = true;

  const bind = (root) => {
    if (root.dataset.bound === 'true') return;
    const cards = [...root.querySelectorAll('.snkrs-rotator__card')];
    if (!cards.length) return;
    root.dataset.bound = 'true';

    let index = 0;
    const interval = Math.max(2, Number(root.dataset.interval) || 4) * 1000;

    const show = (next) => {
      cards.forEach((card, i) => card.classList.toggle('is-active', i === next));
      index = next;
    };

    show(0);
    if (cards.length < 2) return;

    let timer = window.setInterval(() => {
      show((index + 1) % cards.length);
    }, interval);

    root.addEventListener('mouseenter', () => window.clearInterval(timer));
    root.addEventListener('mouseleave', () => {
      timer = window.setInterval(() => {
        show((index + 1) % cards.length);
      }, interval);
    });
  };

  const init = () => {
    document.querySelectorAll('[data-snkrs-rotator]').forEach(bind);
  };

  init();
  document.addEventListener('shopify:section:load', init);
})();

(() => {
  if (window.__snkrsTitleScrollBound) return;
  window.__snkrsTitleScrollBound = true;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (CSS.supports && CSS.supports('animation-timeline', 'view()')) return;

  const nodes = [];

  const collect = () => {
    nodes.length = 0;
    document.querySelectorAll('[data-snkrs-title]').forEach((el) => {
      const banner = el.closest('.snkrs-selection__banner');
      if (banner) nodes.push({ el, banner });
    });
  };

  const update = () => {
    for (const item of nodes) {
      const top = item.banner.getBoundingClientRect().top;
      const max = item.banner.offsetHeight * 0.28;
      const shift = Math.max(-max, Math.min(max, -top * 0.38));
      item.el.style.transform = `translate3d(0, ${shift}px, 0)`;
    }
  };

  collect();
  update();
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update, { passive: true });
  document.addEventListener('shopify:section:load', () => {
    collect();
    update();
  });
})();
